import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { api, errorMessage } from '../api';
import { useAuth } from '../auth';
import { Alert, Field } from '../components/ui';

export function SetupPage() {
  const { needsSetup, setUser, setNeedsSetup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (needsSetup === false) return <Navigate to="/" replace />;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password.length < 12) return setError('Password must be at least 12 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setBusy(true);
    try {
      const r = await api.setup({ name: name.trim(), email: email.trim(), password });
      setNeedsSetup(false);
      setUser(r.user);
      navigate('/batches', { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={onSubmit} noValidate={false}>
        <h1>Set up the admin panel</h1>
        <p className="muted">
          No accounts exist yet. This creates the <strong>first admin account</strong>. You can invite other admins
          and members from the Users page afterwards. This screen disappears once an account exists.
        </p>
        <Field label="Name">{(id) => <input id={id} value={name} onChange={(e) => setName(e.target.value)} required autoComplete="name" autoFocus />}</Field>
        <Field label="Email">
          {(id) => <input id={id} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />}
        </Field>
        <Field label="Password" hint="At least 12 characters.">
          {(id) => (
            <input id={id} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={12} autoComplete="new-password" />
          )}
        </Field>
        <Field label="Confirm password">
          {(id) => (
            <input id={id} type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={12} autoComplete="new-password" />
          )}
        </Field>
        {error && <Alert>{error}</Alert>}
        <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
          {busy ? 'Creating…' : 'Create admin account'}
        </button>
      </form>
    </div>
  );
}
